// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".modal button.delete{height:40px;max-height:40px;max-width:40px;min-height:40px;min-width:40px;width:40px}", ""]);
// Exports
module.exports = exports;
